module.exports = __webpack_public_path__ + "static/media/tooth.4d046b7c.jpg";